import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faAlignLeft,
    faAngleDoubleDown,
    faAngleDoubleUp,
    faAngleLeft,
    faAngleRight,
    faArrowCircleUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowsAltV,
    faArrowUp,
    faArrowUpRightFromSquare,
    faAt,
    faB,
    faBan,
    faBars,
    faBook,
    faBoxArchive,
    faBoxOpen,
    faBriefcase,
    faBrush,
    faBuilding,
    faCalendar,
    faCaretDown,
    faCaretRight,
    faCaretUp,
    faCertificate,
    faChartPie,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleExclamation,
    faCircleNotch,
    faCircleQuestion,
    faClock,
    faClose,
    faCoins,
    faComment,
    faCommentDollar,
    faCompress,
    faCopy,
    faCreditCard,
    faCrop,
    faCropSimple,
    faCrown,
    faDeleteLeft,
    faDownload,
    faEdit,
    faEllipsisV,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faEye,
    faEyeSlash,
    faFile,
    faFileAlt,
    faFileContract,
    faFileCsv,
    faFileImage,
    faFileImport,
    faFilePdf,
    faFilm,
    faFilter,
    faFireFlameCurved,
    faFlag,
    faFolder,
    faFolderOpen,
    faGear,
    faGem,
    faGlobe,
    faGrip,
    faGripVertical,
    faHeadphones,
    faImage,
    faImagePortrait,
    faInbox,
    faInfoCircle,
    faKey,
    faLink,
    faLinkSlash,
    faLock,
    faM,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faMinus,
    faMoneyBill,
    faMoon,
    faPalette,
    faPaperPlane,
    faParagraph,
    faPause,
    faPen,
    faPencilAlt,
    faPenNib,
    faPenSquare,
    faPhone,
    faPhotoVideo,
    faPlay,
    faPlayCircle,
    faPlus,
    faPlusCircle,
    faPlusSquare,
    faProjectDiagram,
    faRepeat,
    faRetweet,
    faRotate,
    faRotateLeft,
    faRotateRight,
    faRssSquare,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faSquare,
    faSquareCaretDown,
    faSquareCaretRight,
    faStar,
    faSun,
    faSync,
    faTimes,
    faTimesCircle,
    faTrash,
    faTrashAlt,
    faTv,
    faUser,
    faUserCircle,
    faUsers,
    faUserShield,
    faUserSlash,
    faVideo
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faAlignLeft,
    faAngleDoubleDown,
    faAngleDoubleUp,
    faAngleLeft,
    faAngleRight,
    faArrowCircleUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowsAltV,
    faArrowUp,
    faArrowUpRightFromSquare,
    faAt,
    faB,
    faBan,
    faBars,
    faBook,
    faBoxArchive,
    faBoxOpen,
    faBriefcase,
    faBrush,
    faBuilding,
    faCalendar,
    faCaretDown,
    faCaretRight,
    faCaretUp,
    faCertificate,
    faChartPie,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleExclamation,
    faCircleNotch,
    faCircleQuestion,
    faClock,
    faClose,
    faCoins,
    faComment,
    faCommentDollar,
    faCompress,
    faCopy,
    faCreditCard,
    faCrop,
    faCropSimple,
    faCrown,
    faDeleteLeft,
    faDownload,
    faEdit,
    faEllipsisV,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faEye,
    faEyeSlash,
    faFile,
    faFileAlt,
    faFileContract,
    faFileCsv,
    faFileImage,
    faFileImport,
    faFilePdf,
    faFilm,
    faFilter,
    faFireFlameCurved,
    faFlag,
    faFolder,
    faFolderOpen,
    faGear,
    faGem,
    faGlobe,
    faGrip,
    faGripVertical,
    faHeadphones,
    faImage,
    faImagePortrait,
    faInbox,
    faInfoCircle,
    faKey,
    faLink,
    faLinkSlash,
    faLock,
    faM,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faMinus,
    faMoneyBill,
    faMoon,
    faPalette,
    faPaperPlane,
    faParagraph,
    faPause,
    faPen,
    faPencilAlt,
    faPenNib,
    faPenSquare,
    faPhone,
    faPhotoVideo,
    faPlay,
    faPlayCircle,
    faPlus,
    faPlusCircle,
    faPlusSquare,
    faProjectDiagram,
    faRepeat,
    faRetweet,
    faRotate,
    faRotateLeft,
    faRotateRight,
    faRssSquare,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faSquare,
    faSquareCaretDown,
    faSquareCaretRight,
    faStar,
    faSun,
    faSync,
    faTimes,
    faTimesCircle,
    faTrash,
    faTrashAlt,
    faTv,
    faUser,
    faUserCircle,
    faUsers,
    faUserShield,
    faUserSlash,
    faVideo
);
